import { Injectable } from '@angular/core';
import {api} from '../../shared/models/global.constants';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {fullName} from '../../shared/tools/person-helper';
import {applyInactiveFlag, applyInactiveMapping} from '../../shared/tools/settings-helper';

const url = api('Users');

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {}

  async load(onlyActive: boolean): Promise<any> {
    try {
      const users = await firstValueFrom(this.http.get<any[]>(`${url}/All/${onlyActive}`));
      users.map((user: any) => {
        fullName(user);
        user.isInactive = !!user.deactivatedOn;
      });
      return users;
    } catch (e) {

      return false;
    }
  }

  async create(user: any): Promise<any> {
    try {
      const response: any = await firstValueFrom(this.http.post(url, user));
      if (response) {
        user.userId = response.userId;
        return user;
      }
      return false;
    } catch (e) {

      return false;
    }
  }

  async update(user: any): Promise<any> {
    try {
      applyInactiveFlag(user);
      const response = await firstValueFrom(this.http.put(`${url}/${user.userId}`, user));
      return true;
    } catch (e) {

      return false;
    }
  }

  async delete(user: any): Promise<any> {
    try {
      return await firstValueFrom(this.http.delete(`${url}/${user.userId}`));
    } catch (e) {

      return false;
    }
  }

  async loadById(id: string): Promise<any> {
    try {
      return await firstValueFrom(this.http.get(`${url}/${id}`));
    } catch (e) {

      return false;
    }
  }

  async changeEmail(body: { value: string }, id: string): Promise<any> {
    try {
      return await firstValueFrom(this.http.patch(`${url}/${id}/Email`, body));
    } catch (e) {

      return false;
    }
  }

  async changePassword(body: { value: string }, id: string): Promise<any> {
    try {
      return await firstValueFrom(this.http.patch(`${url}/${id}/Password`, body));
    } catch (e) {

      return false;
    }
  }

  async checkTokenValidity(body: { value: string }): Promise<any> {
    try {
      return await firstValueFrom(this.http.post(`${url}/CheckTokenValidity`, body));
    } catch (e) {

      return false;
    }
  }

  async loadPermissions(onlyActive: boolean): Promise<any> {
    try {
      let permissions = await firstValueFrom(this.http.get<any>(`${url}/Permissions/${onlyActive}`));
      applyInactiveMapping(permissions);
      return permissions;
    } catch (e) {

      return false;
    }
  }

  async requestApiKey(body: { expiresAfterDays: number }, id: string): Promise<any> {
    try {
      return await firstValueFrom(this.http.post(`${url}/${id}/RequestApiKay`, body));
    } catch (e) {

      return false;
    }
  }
}
